var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7391 22.5772L16.1871 6.04118C15.6591 5.12914 14.339 5.12914 13.811 6.04118L4.25902 22.5772C3.73102 23.4892 4.37905 24.6412 5.43506 24.6412H24.5391C25.6188 24.6412 26.2669 23.4891 25.7389 22.5772H25.7391ZM14.6991 11.1052C15.2751 10.9612 15.851 11.2492 16.115 11.7772C16.2109 11.9692 16.235 12.1852 16.2109 12.3772C16.1629 12.9772 16.139 13.5772 16.115 14.2011C16.067 15.1371 15.995 16.0971 15.9469 17.0331C15.923 17.321 15.923 17.6091 15.8989 17.921C15.8749 18.4251 15.4909 18.809 14.9868 18.809C14.5069 18.809 14.0989 18.4249 14.0748 17.945C14.0028 16.481 13.9067 15.017 13.8347 13.553C13.8108 13.1689 13.7867 12.761 13.7627 12.3769C13.7631 11.8012 14.1471 11.2493 14.6991 11.1053L14.6991 11.1052ZM15.0111 22.0972C14.3391 22.0972 13.8111 21.5452 13.8111 20.8732C13.8111 20.2012 14.3631 19.6493 15.0351 19.6493C15.7071 19.6493 16.2351 20.2012 16.2351 20.8973C16.2111 21.545 15.6592 22.0971 15.0111 22.0971V22.0972Z",
    fill: "#eab308"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.03eb6a077a2ab16f7eec2a2e58b4051f.svg";
export { ForwardRef as ReactComponent };